module.exports = "# Contact\r\n\r\nFor help, feedback, or new feature requests, please send us an email at <imageresize.org@gmail.com>.\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contact/contact.md
// module id = 1145
// module chunks = 0